<template>
  <div class="add_allergy_module trans">
    <img src="@/images/doc_11.png" class="tip_img">
    <div  class="title">推荐其他医生</div>
    <div class="content">若当前咨询的医生未回复，平台会根据</div>
    <div class="content">您的情况为你推荐另一位好评医生</div>
    <div class="content">推荐不需要支付额外费用</div>
    <div class="i_know_btn" @click="gotoFill">我知道了</div>
  </div>
</template>
<script>
export default {
    methods:{
        gotoFill(){
            sessionStorage.removeItem("fillData")
            this.$router.push({path:"fill"})
        }
    }
};
</script>
<style lang="scss" scoped>
.add_allergy_module{
    position: fixed;
    width:295px;
    height:306px;
    background:rgba(255,255,255,1);
    border-radius:5px;
    box-sizing: border-box;
    text-align: center;
    // padding: 0 23px;
    padding-top: 34px;
    .tip_img{
        width: 90px;
        height: 92px;
    }
    .title{
        font-size:18px;
        color:rgba(51,51,51,1);
        margin: 16px auto 13px auto;
        line-height: 18px;
    }
    .content{
        font-size:14px;
        color:rgba(153,153,153,1);
        line-height: 14px;
        margin-bottom: 7px;
    }
    .i_know_btn{
        width:110px;
        height:30px;
        background:#807AF4;
        border-radius:16px;
        line-height: 30px;
        font-size:15px;color: #fff;
        margin: 0 auto;
        margin-top: 19px;
    }
}
</style>